import { Box } from '@mui/material'
import { useMemo } from 'react'
import styles from './ThreadListRow.module.scss'
import { getThreadMenuItems } from './threadRowMenuConfig'
import { useThreadListRowRename } from './useThreadListRowRename.js'
import ThreadListRowTitleEdit from './ThreadListRowTitleEdit.jsx'
import ThreadListRowTitleButton from './ThreadListRowTitleButton.jsx'
import ThreadListRowKebabMenu from './ThreadListRowKebabMenu.jsx'

export default function ThreadListRow(props) {
  const {
    title,
    onClick,
    active = false,
    onMenuClick,
    thread,
    onThreadMenuAction,
    onRenameThread,
    menuSurface = 'threads',
    showNoteIcon = false,
  } = props

  const menuItems = useMemo(() => getThreadMenuItems(menuSurface), [menuSurface])
  const rename = useThreadListRowRename({ title, thread, onRenameThread })

  return (
    <Box className={`${styles.rowShell} ${active ? styles.active : ''}`}>
      {rename.isEditingTitle ? (
        <ThreadListRowTitleEdit {...rename} />
      ) : (
        <ThreadListRowTitleButton title={title} active={active} onClick={onClick} showNoteIcon={showNoteIcon} />
      )}
      {thread ? (
        <ThreadListRowKebabMenu
          menuItems={menuItems}
          isEditingTitle={rename.isEditingTitle}
          onMenuClick={onMenuClick}
          onMenuItemSelect={rename.handleMenuItemSelect}
          onThreadMenuAction={onThreadMenuAction}
          thread={thread}
        />
      ) : null}
    </Box>
  )
}
